import styled from 'styled-components'
import HeaderText from './HeaderText'

const HeaderTextSmall = styled(HeaderText)`
  display: inline-block;
  font-size: ${props => props.theme.fontSizeMedium};
`

export default HeaderTextSmall
